module.exports = __webpack_public_path__ + "img/v4_td5.80b2db30.png";